import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';
// import Cookies from 'js-cookie';

const AdminProfileContext = createContext();

export function AdminProfileProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [settingProfileWorks, setSettingProfileWorks] = useState('');
    const [settingAllProfileWorks, setSettingAllProfileWorks] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchProfile() {
            setLoading(true);
            try {
                const worksAllData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/works`);
                const worksData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/works?${selectedCategory ? `service=${selectedCategory}&` : ""}page=${currentPage}&limit=9`);

                setSettingAllProfileWorks(worksAllData);
                setSettingProfileWorks(worksData);
            } catch (err) {
                setSettingAllProfileWorks(null);
                setSettingProfileWorks(null);

            } finally {
                setLoading(false);
            }
        }
        fetchProfile();
    }, [navigate, currentPage, selectedCategory, setSettingAllProfileWorks, langUrl]);


    return (
        <AdminProfileContext.Provider
            value={{
                loading, setLoading,
                currentPage, setCurrentPage,
                settingProfileWorks, setSettingProfileWorks,
                settingAllProfileWorks, setSettingAllProfileWorks,
                selectedCategory, setSelectedCategory
            }}>
            {children}
        </AdminProfileContext.Provider>
    );
}

export function useAdminProfile() {
    return useContext(AdminProfileContext);
}